import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { withNavigation } from 'src/ui/hoc';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Card, CardContent, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { find, get } from 'lodash';
import { Form, Field } from 'react-final-form';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import {
  getFIPeople,
  fetchFIPeople,
  addFIPerson,
  updateFIPerson,
} from 'src/financial-institution';
import { fetchFormData, getFormData } from 'src/account';
import {
  setBreadcrumbs,
  PanelNavSlot,
  reduceServerErrors,
  SaveChangesToast,
  ConfirmChangesModal,
  InnerLoader,
  UiFieldset,
  UiInputAdapter,
  UiSelectAdapter,
  // UiToggleAdapter,
  clearPhoneNumber,
  UiToastAdapter,
  maskPhone,
} from 'src/ui';
import { email, composeValidators, required } from 'src/ui/validations';
import { PHONE_MASK } from 'src/ui/const';
import { getUser } from '../redux';
// import { PERSON_TYPE_SELECT_OPTIONS } from '../const';

class UsersEditPage extends Component {
  state = {
    title: 'Add',
    loading: true,
    initialValues: {},
    confirmChangesModal: false,
  };

  async componentDidMount() {
    const {
      fetchFormData,
      setBreadcrumbs,
      fetchFIPeople,
      user,
      match,
    } = this.props;
    const { id } = match.params;
    const { financialInstitutionId, accountId } = user;

    const title = id ? 'Edit' : 'Add';
    this.setState({ title });
    setBreadcrumbs([
      { label: 'Users', href: '/users' },
      { label: title, href: match.url },
    ]);

    const promises = [fetchFormData(financialInstitutionId, accountId)];
    if (id) {
      promises.push(fetchFIPeople({ financialInstitutionId }));
    }
    await Promise.all(promises);

    const { formData, people } = this.props;
    if (formData.isError()) {
      reduceServerErrors(formData);
    }
    if (people.isError()) {
      reduceServerErrors(people);
    }
    const person = people.items.find(item => item.id === +id);
    this.setInitialValues(person);

    this.setState({ loading: false });
  }

  setInitialValues(person) {
    if (person) {
      const { formData } = this.props;
      this.setState({
        initialValues: {
          ...person,
          roleId: find(formData.personRoles, { id: person.roleId }),
          primaryNumber:
            person.primaryNumber && maskPhone(person.primaryNumber),
        },
      });
    }
  }

  handleSubmit = async values => {
    const { match, user, updateFIPerson, addFIPerson, history } = this.props;
    const { initialValues } = this.state;
    const { id } = match.params;
    const { financialInstitutionId } = user;

    const data = {
      ...initialValues,
      ...values,
      financialInstitutionId,
      primaryNumber: clearPhoneNumber(values.primaryNumber),
      roleId: get(values.roleId, 'id', null),
      expirationNotificationFrequency: values.expirationNotificationFrequency,
      receiveExpirationNotification: values.receiveExpirationNotification,
      notifyOnDocumentUpload: values.notifyOnDocumentUpload,
      sendEmail: true,
    };

    if (id) {
      data.personId = id;
      await updateFIPerson(data);
    } else {
      await addFIPerson(data);
    }

    const { formData, people } = this.props;

    if (formData.isError()) {
      return reduceServerErrors(formData);
    }
    if (people.isError()) {
      return reduceServerErrors(people);
    }

    if (id) {
      toast(UiToastAdapter('User updated successfully!', 'success'));
    } else {
      toast(UiToastAdapter('User added successfully!', 'success'));
    }
    history.push('/users');
    return undefined;
  };

  showModal = () => this.setState({ confirmChangesModal: true });

  hideModal = () => this.setState({ confirmChangesModal: false });

  render() {
    const { initialValues, loading, confirmChangesModal, title } = this.state;
    const { isExpanded, formData } = this.props;

    const toastContainerClassName = classNames('bottom-toast-container', {
      'is-condensed': !isExpanded,
    });

    return (
      <>
        <PanelNavSlot>
          <NavLink className="close-page button is-small is-text" to="/users">
            <span className="icon has-text-danger">
              <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
            </span>
          </NavLink>
        </PanelNavSlot>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          {`${title} User`}
        </MuiTitle>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          subscription={{
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtySinceLastSubmit: true,
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
          }) => (
            <Card tag="form" onSubmit={handleSubmit} noValidate>
              <CardContent>
                <div className={toastContainerClassName}>
                  <SaveChangesToast
                    message="Click the button to the right to save your changes"
                    isLoading={submitting}
                    isDisabled={submitting || hasValidationErrors}
                    isVisible={dirty || dirtySinceLastSubmit}
                    onClickButton={this.showModal}
                  />
                </div>
                <ConfirmChangesModal
                  title="Users"
                  isActive={confirmChangesModal}
                  onClickCancel={this.hideModal}
                  onClickSubmit={this.hideModal}
                />
                <InnerLoader visible={submitting || loading} />
                <UiFieldset title="Primary data" isFirst>
                  <Columns isMultiline>
                    <Column isSize="1/2">
                      <Field
                        component={UiInputAdapter}
                        name="firstName"
                        id="firstName"
                        label="First Name"
                        required
                        validate={composeValidators('First Name', required)}
                      />
                    </Column>
                    <Column isSize="1/2">
                      <Field
                        component={UiInputAdapter}
                        name="lastName"
                        id="lastName"
                        label="Last Name"
                        required
                        validate={composeValidators('Last Name', required)}
                      />
                    </Column>
                    <Column isSize="1/3">
                      <Field
                        component={UiInputAdapter}
                        name="emailAddress"
                        id="emailAddress"
                        label="Email address"
                        required
                        validate={composeValidators(
                          'Email Address',
                          required,
                          email
                        )}
                      />
                    </Column>
                    <Column isSize="1/3">
                      <Field
                        component={UiInputAdapter}
                        name="primaryNumber"
                        id="primaryNumber"
                        label="Primary number"
                        required
                        mask={PHONE_MASK}
                        validate={composeValidators('Primary Number', required)}
                      />
                    </Column>
                  </Columns>
                </UiFieldset>

                <UiFieldset title="User Permissions">
                  <Columns isMultiline>
                    <Column isSize="2/3">
                      <Field
                        component={UiSelectAdapter}
                        name="roleId"
                        id="roleId"
                        options={formData.personRoles || []}
                        getOptionValue={item => item.id}
                        getOptionLabel={item => item.name}
                        label="User role"
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
              </CardContent>
            </Card>
          )}
        />
      </>
    );
  }
}

UsersEditPage.propTypes = {
  match: propTypes.object.isRequired,
  history: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  people: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  fetchFIPeople: propTypes.func.isRequired,
  addFIPerson: propTypes.func.isRequired,
  updateFIPerson: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  isExpanded: propTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    people: getFIPeople(state),
    formData: getFormData(state),
  };
}

const connectedUsersEditPage = connect(mapStateToProps, {
  fetchFIPeople,
  fetchFormData,
  setBreadcrumbs,
  addFIPerson,
  updateFIPerson,
})(withNavigation(UsersEditPage));

export { connectedUsersEditPage as UsersEditPage };
